import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { EddyAutoComplete, Licitacao, LicitacaoTestemunha, Login, Pessoa, PessoaService } from 'eddydata-lib';
import { ConfirmationService } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as toastr from 'toastr';
import { LicitacaoTestemunhaService } from './service/licitacao-testemunha.service';

@Component({
  selector: 'app-licitacao-testemunha',
  templateUrl: './licitacao-testemunha.component.html'
})
export class LicitacaoTestemunhaComponent implements OnInit, OnDestroy {

  public pessoaAutoComplete: EddyAutoComplete<Pessoa>;
  public pessoaAtual: Pessoa;

  @Input() entidade: Licitacao;
  @Input() login: Login;

  protected unsubscribe: Subject<void> = new Subject();

  constructor(
    protected confirmationService: ConfirmationService,
    protected pessoaService: PessoaService,
    protected testemunhaService: LicitacaoTestemunhaService,
  ) { }

  ngOnInit(): void {
    this.pessoaAutoComplete = new EddyAutoComplete(null, this.pessoaService,
      'id', ['nome'], { cidade_id: this.login.cidade.id, orderBy: 'nome' }, { number: ['id', 'cpf_cnpj'], text: ['nome'] }
    );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public adicionar(pessoa?: Pessoa) {
    if (!pessoa) pessoa = this.pessoaAtual;
    if (pessoa) {
      if (!this.entidade.testemunhas) {
        this.entidade.testemunhas = [];
      }

      if (this.entidade.testemunhas.find((f) => f.pessoa.id === pessoa.id)) {
        toastr.warning('Testemunha já incluída nesta licitação!');
      } else {
        const item = new LicitacaoTestemunha()
        item.pessoa = pessoa;

        this.entidade.testemunhas.push(item);
      }
      pessoa = undefined;
      this.pessoaAtual = undefined;
    }
  }

  public remover(item: LicitacaoTestemunha, index: number) {
    if (item.id) {
      this.confirmationService.confirm({
        message: 'Deseja realmente remover a testemunha?',
        header: 'Exclusão',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Confirmar',
        rejectLabel: 'Cancelar',
        accept: () => {
          this.testemunhaService.remover(item.id).pipe(takeUntil(this.unsubscribe))
            .subscribe((res) => {
              toastr.info('Registro removido com sucesso!', 'Exclusão');
              this.entidade.testemunhas.splice(index, 1);
            }, (err) => toastr.error(err.error.payload));
        }
      });
    } else {
      this.entidade.testemunhas.splice(index, 1);
    }
  }

}
